<template>
  <ion-list>
    <ion-list-header>
      <ion-label>
        Hauptelemente
      </ion-label>
    </ion-list-header>
    <ion-item
      button
      @click="goToHome"
    >
      <ion-icon
        slot="start"
        name="home"
      />
      <ion-label>
        Home
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToSpecials"
    >
      <ion-icon
        slot="start"
        name="pricetags"
      />
      <ion-label>
        Specials
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToRallys"
    >
      <ion-icon
        slot="start"
        name="map"
      />
      <ion-label>
        Rallys
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      class="menu-item--child"
      @click="goToRallyCategories"
    >
      <ion-icon
        slot="start"
        name="pricetag"
      />
      <ion-label>
        Tour-Kategorien
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      class="menu-item--child"
      @click="goToUserSegments"
    >
      <ion-icon
        slot="start"
        name="people"
      />
      <ion-label>
        Nutzer-Segmente
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToCompanies"
    >
      <ion-icon
        slot="start"
        name="business"
      />
      <ion-label>
        Companies
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      class="menu-item--child"
      @click="goToCategories"
    >
      <ion-icon
        slot="start"
        name="list"
      />
      <ion-label>
        Lokal-Kategorien
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToCompanyImport"
    >
      <ion-icon
        slot="start"
        name="cloud-download"
      />
      <ion-label>
        Partner-Import
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToDealImagePrompts"
    >
      <ion-icon slot="start" name="color-wand" />
      <ion-label>KI Bild-Prompt</ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToDealImageLibraryUpload"
    >
      <ion-icon slot="start" name="images" />
      <ion-label>Bild-Bibliothek Upload</ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToDealTemplates"
    >
      <ion-icon
        slot="start"
        name="bookmark"
      />
      <ion-label>
        Deal-Vorlagen
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToReviews"
    >
      <ion-icon
        slot="start"
        name="star"
      />
      <ion-label>
        Bewertungen
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToMemberReports"
    >
      <ion-icon
        slot="start"
        name="flag"
      />
      <ion-label>
        Mitgliedermeldungen
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToSupportInbox"
    >
      <ion-icon
        slot="start"
        name="chatbubbles"
      />
      <ion-label>
        Support-Chat
      </ion-label>
      <ion-badge
        v-if="supportUnreadCount > 0"
        slot="end"
        color="danger"
      >
        {{ supportUnreadBadgeLabel }}
      </ion-badge>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToInvitationSettings"
    >
      <ion-icon
        slot="start"
        name="person-add"
      />
      <ion-label>
        Einladungen
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToInvitationCodes"
    >
      <ion-icon
        slot="start"
        name="qr-code"
      />
      <ion-label>
        Einladungscodes
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToInvitationCodeBatches"
    >
      <ion-icon
        slot="start"
        name="albums"
      />
      <ion-label>
        Code-Stapel
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToMemberPointsSettings"
    >
      <ion-icon
        slot="start"
        name="cash"
      />
      <ion-label>
        Member-Punkte
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToPartnerPointsSettings"
    >
      <ion-icon
        slot="start"
        name="cash"
      />
      <ion-label>
        Partner-Punkte
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToPromoterPointsSettings"
    >
      <ion-icon
        slot="start"
        name="cash"
      />
      <ion-label>
        Promoter-Punkte
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToPartnerInvoices"
    >
      <ion-icon
        slot="start"
        name="receipt"
      />
      <ion-label>
        Partner-Rechnungen
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToPartnerCommissionSettings"
    >
      <ion-icon
        slot="start"
        name="calculator"
      />
      <ion-label>
        Provisions-Sätze
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToUserCompanyVisibilityFilter"
    >
      <ion-icon
        slot="start"
        name="eye-off"
      />
      <ion-label>
        Lokal-Sichtbarkeit
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToPotentialDealSavings"
    >
      <ion-icon
        slot="start"
        name="cash"
      />
      <ion-label>
        Potenzielle Ersparnis
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToPartnerActiveDealLimitSettings"
    >
      <ion-icon
        slot="start"
        name="albums"
      />
      <ion-label>
        Aktive-Deals-Limit
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToNotifications"
    >
      <ion-icon
        slot="start"
        name="notifications"
      />
      <ion-label>
        Benachrichtigungen
      </ion-label>
    </ion-item>
  </ion-list>
</template>
<script>
import { mapState } from 'vuex';
import { IonBadge } from '@ionic/vue';

const SUPPORT_UNREAD_POLL_MS = 45000;

export default {
  name: 'MenuNavigate',
  components: { IonBadge },
  data: () => ({
    supportUnreadPollTimer: null,
  }),
  computed: {
    ...mapState('auth', ['role', 'authorized']),
    ...mapState('supportInbox', ['unreadCount']),
    supportUnreadCount() {
      return Number(this.unreadCount) || 0;
    },
    supportUnreadBadgeLabel() {
      if (this.supportUnreadCount > 99) return '99+';
      return String(this.supportUnreadCount);
    },
  },
  watch: {
    authorized(isAuthorized) {
      this.syncSupportUnreadPolling(isAuthorized && this.role === 'admin');
    },
    role(nextRole) {
      this.syncSupportUnreadPolling(this.authorized && nextRole === 'admin');
    },
  },
  mounted() {
    this.syncSupportUnreadPolling(this.authorized && this.role === 'admin');
  },
  beforeUnmount() {
    this.stopSupportUnreadPolling();
  },
  methods: {
    syncSupportUnreadPolling(shouldPoll) {
      if (!shouldPoll) {
        this.stopSupportUnreadPolling();
        this.$store.commit('supportInbox/setUnreadCount', 0);
        return;
      }
      this.refreshSupportUnreadBadge();
      this.stopSupportUnreadPolling();
      this.supportUnreadPollTimer = window.setInterval(() => {
        this.refreshSupportUnreadBadge();
      }, SUPPORT_UNREAD_POLL_MS);
    },
    stopSupportUnreadPolling() {
      if (this.supportUnreadPollTimer) {
        clearInterval(this.supportUnreadPollTimer);
        this.supportUnreadPollTimer = null;
      }
    },
    refreshSupportUnreadBadge() {
      this.$store.dispatch('supportInbox/refresh').catch(() => {});
    },
    goToHome() {
      this.$router.push('/').catch(() => {});
    },
    goToLogin() {
      this.$router.push('/login').catch(() => {});
    },
    goToSpecials() {
      this.$router.push('/specials').catch(() => {});
    },
    goToRallys() {
      this.$router.push('/rallys').catch(() => {});
    },
    goToAdminInfo() {
      this.$router.push('/adminInfo').catch(() => {});
    },
    goToCompanies() {
      this.$router.push('/companies').catch(() => {});
    },
    goToCompanyImport() {
      this.$router.push('/company-import').catch(() => {});
    },
    goToCategories() {
      this.$router.push('/categories').catch(() => {});
    },
    goToRallyCategories() {
      this.$router.push('/rally-categories').catch(() => {});
    },
    goToUserSegments() {
      this.$router.push('/user-segments').catch(() => {});
    },
    goToDealTemplates() {
      this.$router.push('/deal-templates').catch(() => {});
    },
    goToDealImagePrompts() {
      this.$router.push('/deal-image-prompts').catch(() => {});
    },
    goToDealImageLibraryUpload() {
      this.$router.push('/deal-image-library-upload').catch(() => {});
    },
    goToReviews() {
      this.$router.push('/reviews').catch(() => {});
    },
    goToMemberReports() {
      this.$router.push('/member-reports').catch(() => {});
    },
    goToSupportInbox() {
      this.$router.push('/support').catch(() => {});
    },
    goToPartnerPointsSettings() {
      this.$router.push('/partner-points-settings').catch(() => {});
    },
    goToMemberPointsSettings() {
      this.$router.push('/member-points-settings').catch(() => {});
    },
    goToInvitationSettings() {
      this.$router.push('/invitation-settings').catch(() => {});
    },
    goToInvitationCodes() {
      this.$router.push('/invitation-codes').catch(() => {});
    },
    goToInvitationCodeBatches() {
      this.$router.push('/invitation-code-batches').catch(() => {});
    },
    goToPromoterPointsSettings() {
      this.$router.push('/promoter-points-settings').catch(() => {});
    },
    goToPartnerInvoices() {
      this.$router.push('/partner-invoices').catch(() => {});
    },
    goToPartnerCommissionSettings() {
      this.$router.push('/partner-commission-settings').catch(() => {});
    },
    goToUserCompanyVisibilityFilter() {
      this.$router.push('/user-company-visibility-filter').catch(() => {});
    },
    goToPotentialDealSavings() {
      this.$router.push('/potential-deal-savings').catch(() => {});
    },
    goToPartnerActiveDealLimitSettings() {
      this.$router.push('/partner-active-deal-limit-settings').catch(() => {});
    },
    goToNotifications() {
      this.$router.push('/notifications').catch(() => {});
    },
  },
};
</script>
<style>
  ion-list {
    background-color: #a9d162;
  }

  /* Sub-items: same icon column as siblings; hierarchy only on the label */
  ion-item.menu-item--child {
    --min-height: 42px;
  }

  ion-item.menu-item--child ion-label {
    margin-left: 2px;
    padding-left: 10px;
    border-left: 2px solid rgba(0, 0, 0, 0.14);
  }
</style>
